import React, { useState } from "react";
import PropTypes from "prop-types";

function AttendanceActionsMenu({ canUndoWholeLessonCancellation, onAction }) {
  const [open, setOpen] = useState(false);

  const handleAction = (action) => {
    setOpen(false);
    onAction(action);
  };

  return (
    <div className="attendance-page__actions">
      <button type="button" className="btn btn-outline-secondary" onClick={() => setOpen(!open)}>
        Akcje lekcji
        <span className="attendance-page__actions-chevron" aria-hidden="true">⌄</span>
      </button>
      {open && (
        <div className="attendance-page__actions-menu">
          <button type="button" onClick={() => handleAction("lesson-details")}>Zmień dane zajęć</button>
          <button type="button" onClick={() => handleAction("absence-report")}>Zgłoszenie nieobecności</button>
          <button type="button" onClick={() => handleAction("lesson-cancellation")}>Odwołaj lekcję</button>
          {canUndoWholeLessonCancellation && (
            <button type="button" onClick={() => handleAction("undo-cancellation")}>Cofnij odwołanie</button>
          )}
          <button type="button" onClick={() => handleAction("student-list")}>Zarządzaj listą uczniów</button>
        </div>
      )}
    </div>
  );
}

AttendanceActionsMenu.propTypes = {
  canUndoWholeLessonCancellation: PropTypes.bool,
  onAction: PropTypes.func.isRequired,
};

AttendanceActionsMenu.defaultProps = {
  canUndoWholeLessonCancellation: false,
};

export default AttendanceActionsMenu;
